// 下载流程聚合：封装配置、数据准备、执行与弹窗控制，向页面暴露 downloadData 与 open/confirm/close
import { useCallback, useMemo, useState } from 'react';
import { useDownloadConfig } from './useDownloadConfig';
import { useDownloadData } from './useDownloadData';
import { useDownloadExecution } from './useDownloadExecution';
import { IUseDownloadFlowParams } from '../types';

/**
 * 聚合下载流程的 Hook：配置、数据准备、执行与弹窗控制
 */
export const useDownloadFlow = ({
  xAxis,
  legends = [],
  filterInfo = [],
  dimensionInfo = [],
  metricsInfo = [],
  filterVal,
  currentMetric,
  rawData = [],
  metricObj = {},
  downloadTitle,
  tableInfo,
  additional_table_field,
}: IUseDownloadFlowParams) => {
  const downloadConfig = useDownloadConfig({
    xAxis,
    legends,
  });

  const downloadData = useDownloadData({
    filterInfo,
    dimensionInfo,
    metricsInfo,
    config: downloadConfig,
    currentFilterVal: filterVal,
    currentMetric,
  });

  const { execute } = useDownloadExecution({
    config: downloadConfig,
    context: {
      rawData,
      metricsInfo,
      dimensionInfo,
      xAxis,
      legends,
      filterInfo,
      filterVal,
      metricObj,
      effectiveSelected: downloadData.effectiveSelected,
      additional_table_field,
    },
  });

  const [modalVisible, setModalVisible] = useState(false);

  const hasFiltersOrMetrics = useMemo(() => {
    const hasFilterUI = downloadData.filters.some((item) => item.options.length > 1);
    const hasMetricUI = downloadData.metrics.length > 1;
    return hasFilterUI || hasMetricUI;
  }, [downloadData.filters, downloadData.metrics]);

  const openDownload = useCallback(() => {
    if (hasFiltersOrMetrics) {
      setModalVisible(true);
    } else {
      execute(
        downloadData.effectiveSelected.filters,
        downloadData.effectiveSelected.metrics,
        downloadTitle,
        tableInfo,
      );
    }
  }, [hasFiltersOrMetrics, execute, downloadData.effectiveSelected.filters, downloadData.effectiveSelected.metrics, downloadTitle, tableInfo]);

  const closeDownload = useCallback(() => setModalVisible(false), []);

  const confirmDownload = useCallback((selectedValues: {
    filters: { [key: string]: string[]; };
    metrics: string[];
  }) => {
    execute(selectedValues.filters, selectedValues.metrics, downloadTitle, tableInfo);
    setModalVisible(false);
  }, [execute, downloadTitle, tableInfo]);

  return {
    downloadData,
    modalVisible,
    hasFiltersOrMetrics,
    openDownload,
    closeDownload,
    confirmDownload,
  };
};


